/**
 * Quick buy (drawer + mobile popover) tweaks:
 *  - stay-in-place confirmation: the add-to-cart button reads "✓ Added · View cart" for a moment instead of
 *    closing the popover / popping a cart toast, so shoppers can keep adding from a collection
 *  - free-shipping bar highlights the threshold that matches the selected Skio plan
 */
(function () {
  'use strict';

  var CONFIRM_MS = 2200;

  function strings() { return (window.themeVariables && window.themeVariables.strings) || {}; }
  function inQuickBuy(el) { return el && el.closest('quick-buy-drawer, quick-buy-popover'); }

  // --- Added confirmation ------------------------------------------------------------------------
  // Suppress the theme's cart toast for quick-buy forms (cancelable event, capture phase so we run first)
  document.addEventListener('cart-notification:show', function (event) {
    if (event.detail && event.detail.status === 'success' && inQuickBuy(event.target)) event.preventDefault();
  }, true);

  // The theme opens the mini cart after an add unless the form sits in a .drawer; the mobile popover is not one.
  var suppressMiniCartUntil = 0;
  document.addEventListener('cart:refresh', function (event) {
    if (Date.now() < suppressMiniCartUntil && event.detail) event.detail.openMiniCart = false;
  }, true);

  function onAdded(event) {
    var form = (event.detail && event.detail.form) || (event.target.closest ? event.target.closest('form') : null);
    var host = inQuickBuy(form);
    if (!form || !host) return;
    suppressMiniCartUntil = Date.now() + 4000;
    var button = form.querySelector('[data-product-add-to-cart-button]');
    if (!button || button._confirming) return;
    var label = button.querySelector('.loader-button__text') || button;
    var original = label.innerHTML;
    button._confirming = true;
    button.classList.add('is-added');
    label.innerHTML = '<span class="quick-buy-added">✓ ' + 'Added' +
      ' · <a class="quick-buy-added__cart" href="' + (window.themeVariables.routes.cartUrl || '/cart') + '">' + (strings().cartViewCart || 'View cart') + '</a></span>';
    setTimeout(function () {
      label.innerHTML = original;
      button.classList.remove('is-added');
      button._confirming = false;
    }, CONFIRM_MS);
  }
  document.addEventListener('variant:added', onAdded);   // drawer (desktop)
  document.addEventListener('quick-buy:added', onAdded); // popover (mobile), re-dispatched above

  // "View cart" inside a submit button: open the cart drawer (or go to the cart page) without resubmitting
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.quick-buy-added__cart');
    if (!link) return;
    event.preventDefault();
    event.stopPropagation();
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    var miniCart = document.getElementById('mini-cart');
    if (settings.cartType === 'drawer' && miniCart) {
      var host = inQuickBuy(link);
      if (host) host.open = false;
      miniCart.open = true;
    } else {
      location.href = link.href;
    }
  }, true);

  // --- Free-shipping bar follows the selected plan ------------------------------------------------
  function syncShippingBar(form) {
    var host = inQuickBuy(form) || form;
    var bar = host.querySelector('.free-shipping-bar');
    if (!bar) return;
    var plan = host.querySelector('[name="selling_plan"]');
    var subscribed = !!(plan && plan.value && !plan.disabled);
    bar.classList.toggle('free-shipping-bar--subscription', subscribed);
    bar.classList.toggle('free-shipping-bar--onetime', !subscribed);
  }
  function keepPopoverOpen(host) {
    if (host._stayOpen || host.tagName !== 'QUICK-BUY-POPOVER') return;
    host._stayOpen = true;
    // The theme closes the popover on variant:added (bubble listener on the host). A capture listener on the
    // same host runs first; stopping propagation there skips the host's bubble listeners. The cart count still
    // updates because the form dispatches cart:refresh on <html> separately.
    host.addEventListener('variant:added', function (event) {
      event.stopPropagation();
      document.dispatchEvent(new CustomEvent('quick-buy:added', { detail: { form: event.target.closest('form') } }));
    }, true);
  }
  function watchForm(form) {
    if (form._shipWatched) return;
    form._shipWatched = true;
    keepPopoverOpen(inQuickBuy(form));
    var sync = function () { setTimeout(function () { syncShippingBar(form); }, 0); };
    var host = inQuickBuy(form) || form; // blocks (Skio picker, shipping bar) sit next to the form, not inside it
    host.addEventListener('change', sync);
    host.addEventListener('click', sync); // Skio radios live in a shadow root; click is composed, change is not
    new MutationObserver(sync).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled', 'name'] });
    sync();
  }
  function scan() {
    document.querySelectorAll('quick-buy-drawer form[is="product-form"], quick-buy-popover form[is="product-form"]').forEach(watchForm);
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
